import React from "react";
import "./Styles/NotebookLogoMark.css";
import dcrtLogo from "./Logos/DCRT_Logo-removebg-preview.png";

/**
 * Lined “notebook slip” with DCRT logo — use in navbar (compact) or homepage corner (larger).
 */
export default function NotebookLogoMark({ variant = "corner", caption, className = "" }) {
    const rootClass = `notebook-mark notebook-mark--${variant}${className ? ` ${className}` : ""}`;

    return (
        <div className={rootClass}>
            {caption != null && caption !== false && (
                <p className="notebook-mark-caption">
                    <span className="notebook-mark-caption-inner">{caption}</span>
                </p>
            )}
            <div className="notebook-mark-scene">
                <div className="notebook-mark-paper">
                    <span className="notebook-mark-tape notebook-mark-tape--tl" aria-hidden="true" />
                    <span className="notebook-mark-tape notebook-mark-tape--tr" aria-hidden="true" />
                    <span className="notebook-mark-tape notebook-mark-tape--br" aria-hidden="true" />
                    <span className="notebook-mark-tape notebook-mark-tape--bl" aria-hidden="true" />
                    <div className="notebook-mark-inner">
                        <span className="notebook-mark-margin" aria-hidden="true" />
                        <span className="notebook-mark-lines" aria-hidden="true" />
                        <span className="notebook-mark-crease notebook-mark-crease--a" aria-hidden="true" />
                        <span className="notebook-mark-crease notebook-mark-crease--b" aria-hidden="true" />
                        <img
                            src={dcrtLogo}
                            alt=""
                            className="notebook-mark-img"
                            width={200}
                            decoding="async"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
